import {Timeline, TimelineLite, TweenLite} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {TombOfAkhenatenParsedGameData} from "../../server/data/TombOfAkhenatenParsedGameData";
import {TOAGameEvent} from "../../events/TOAGameEvent";
import {TombOfAkhenatenParsedInitData} from "../../server/data/TombOfAkhenatenParsedInitData";
import {TombOfAkhenatenGameConfig} from "../../TombOfAkhenatenGameConfig";
import {TombOfAkhenatenGameMode} from "../../gameMode/TombOfAkhenatenGameMode";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {SoundManager} from "../../sound/SoundManager";

export class SpinStart implements GameRoundPresentation {
    stagger?: number;
    abortStagger?: number;

    public static isFullStickyReel : boolean = false;
    private readonly _isNewGameRound: boolean = false;
    private readonly _isWinningSymSticky: boolean = false;

    constructor(isNewRound?: boolean, isStickySyms?: boolean, stagger?: number, abortStagger?: number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;

        this._isNewGameRound = isNewRound ? isNewRound : false;
        this._isWinningSymSticky = isStickySyms ? isStickySyms : false;
    }

    public getAnimation(data: TombOfAkhenatenParsedGameData | TombOfAkhenatenParsedInitData): Timeline | null {
        let stickyReels: number[] = [];
        SpinStart.isFullStickyReel = false;
        if (data.nextMode === TombOfAkhenatenGameMode.NORMAL || data.nextMode === TombOfAkhenatenGameMode.FREESPIN) {
            stickyReels = [0, 1, 5, 6, 10, 11, 15, 16, 20, 21];
        } else if (data.nextMode.indexOf("FIRST") > -1) {
            stickyReels = [0, 2, 3, 4, 5, 7, 8, 9, 10, 12, 13, 14, 15, 17, 18, 19, 20, 22, 23, 24];
        } else if (data.nextMode.indexOf("SECOND") > -1) {
            stickyReels = [1, 2, 3, 4, 6, 7, 8, 9, 11, 12, 13, 14, 16, 17, 18, 19, 21, 22, 23, 24];
        } else {
            let stickySymbols: string[] = (data.stickySymbols).reduce(function (prev, next) {
                return prev.concat(next);
            });

            for (let i: number = 0; i < stickySymbols.length; i++) {
                if (stickySymbols[i] !== "X") {
                    stickyReels.push(i);
                }
            }
            if(stickyReels.length == data.reels.length){
                SpinStart.isFullStickyReel = true;
            }
        }

        for (let i: number = 0; i < stickyReels.length; i++) {
            Reels.getReel(stickyReels[i])!.startSpin({active: false, fastSpin: GameSetting.isFastSpin}, 0);
        }

        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            //do nothing or add delay if required.
        });
        if (TombOfAkhenatenGameConfig.instance.GAME_RESTORED) {
            tl.add(TweenLite.to(() => {
                //blank tween
            }, 0.75, {}));
        }
        tl.add(()=> SoundManager.playReelSpinningSound());
        return tl;
    }

    public prepare(data: TombOfAkhenatenParsedGameData | TombOfAkhenatenParsedInitData): void {
        let gameConfig = TombOfAkhenatenGameConfig.instance;

        gameConfig.WINNING_SYMS_STICKY = this._isWinningSymSticky;
        gameConfig.ACTIVE_ROWS_NEXT_SPIN = data.activeRowsNextSpin;
        gameConfig.GAME_RESTORED = false;
        gameConfig.STONE_PRESS_DURATION = GameSetting.isFastSpin ? 0.1 : 0.15;
        gameConfig.STONE_PRESS_START_DELAY = GameSetting.isFastSpin ? 0.05 : 0.05;
        gameConfig.STONE_LIFT_DURATION = GameSetting.isFastSpin ? 0.5 : 1;
        gameConfig.STONE_LIFT_START_DELAY = GameSetting.isFastSpin ? 0.05 : 0.1;

        if (this._isNewGameRound) {
            gameConfig.REELS_ON_TOP = [];
            EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.UPDATE_REEL_POSITIONS));
            if (data.nextMode === TombOfAkhenatenGameMode.NORMAL) {
                EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.RESET_MULTIPLIER));
            }
            EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.ON_NEW_GAME_ROUND));
            EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.UPDATE_STONE_WAYS, 3));
        }
        EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.ON_SPIN_START));
        if(data.activeRowsNextSpin == 3 && data.activeRows == 3){
            TweenLite.delayedCall(0.3 , ()=>EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.RE_ARRANGE_REEL_SEQUENCE)));
        }else{
            EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.RE_ARRANGE_REEL_SEQUENCE));
        }
        EventHandler.dispatchEvent(new GameEvent("stopIndividualWinForAS",false));
    }
}